import { FunctionComponent } from 'react';
import { useRouterContext } from '@/context/RouterContext';
import { ThreeCanvas } from '@/components/ThreeCanvas';
import { ConditionalPerf } from '@/components/ConditionalPerf';
import { Scene } from '@/components/Scene';
import { Talk } from '@/components/views/Talk';
import { Points } from '@/components/views/Points';
import { Discord } from '@/components/views/Discord';
import { STL } from '@/components/views/STL';

export const Views: FunctionComponent = () => {
    const { view, setScene } = useRouterContext();

    if (view.name === 'TALK') {
        return <Talk />;
    }

    if (view.name === 'POINTS') {
        return <Points />;
    }

    if (view.name === 'DISCORD') {
        return <Discord />;
    }

    if (view.name === 'STL') {
        return <STL />;
    }

    return (
        <div id="canvas-container" style={{ height: '100%', width: '100%', position: 'fixed', userSelect: 'none' }}>
            <ThreeCanvas>
                <ConditionalPerf />
                <Scene scene={view.scene} setScene={setScene} />
            </ThreeCanvas>
        </div>
    );
};
